import React from 'react';
import { useTheme } from '../context/ThemeContext';

export default function Footer() {
  const { tenantConfig } = useTheme();

  if (!tenantConfig) return null;

  return (
    <footer style={{
      textAlign: 'center',
      padding: '24px',
      backgroundColor: 'var(--bg-color)',
      borderTop: '1px solid var(--border-color)',
      color: 'var(--text-mute)',
      fontSize: '13px'
    }}>
      <p>
        &copy; {new Date().getFullYear()}{' '}
        <strong style={{ color: 'var(--accent-color)' }}>{tenantConfig.brand_name}</strong>. 
        All rights reserved.
      </p>
      <p style={{ fontSize: '11px', marginTop: '6px', color: 'var(--primary-color)' }}>
        Powered by TrophyCoin White-Label Network
      </p>
    </footer>
  );
}
